import {
	INCREMENT,
	SHOW,
	XZKM,
	selectProj
	
} from './types'
 // import getters from './getters'
import Vue from 'vue'
// import axios from 'axios'
// Vue.prototype.$http = axios;
export default {
	[INCREMENT](state) {
		state.count++;
	},
	[SHOW](state,list) {
		list.see= !list.see;
	},
	[XZKM](state,{list,data}) {
		list.popupVisible1 = true;
		if(data.length>0){
			state.kmList=data;
		}
	},
	setOrgUserDatas(state, data) {
 		state.orgUserDatas = data
 	},
	setOrgDatas(state, data) {
		state.orgDatas = data
	},
	setPositionList(state, data) {
		state.positionList = data
	},
};
 // export default {
 // 	mutations,
 // 	getters
 // }


// WEBPACK FOOTER //
// ./src/store/mutations.js